<template>
  <div>



      <div 
         class="bee_reward_base_layout"  id="bee_reward_base_layout"
          @click="moveLeftDiv"
           @mousedown="startDrag"
           @touchstart="startTouchDrag"
           :style="{ transform: `translate3d(${dragX}px, ${dragY}px, 0)` }"  style="display: flex; flex-direction: column; align-items: center;" >

      <div class="icon_xp_img" id="xp_down" />

      <div class="reward_content" >
        <div class="reward_content_radius">
          <div class="reward_xp_layout">
            <div v-if="xpValue > 1000000" class="xp_txt" style="font-size: 12px;">+<span style="color: #fff;">{{
              xpValue
                }}</span>
            </div>
            <div else="xpValue > 100000" class="xp_txt">+<span style="color: #fff;">{{ xpValue }}</span>
            </div>

          </div>

          <div v-if="!isUserLoginStatus" class="reward_text" @click="getReceive">Claim</div>

        </div>


      </div>

    </div>
    </div>


    <div class="bee_reward_pg_layout" v-show="isShowPageMint">

      <div class="xp_gif" id="gif_mint"></div>

      <div class="pageMintNum" id="page_mint" style="display: none;">+100</div>




  </div>
</template>

<script>

import Toast from "./message.js";
import { AccountStore } from "../util/Account.js";
import { MintInfoStore } from "../util/MintInfo.js";
import { isHostPage, hostHref } from "../util/mock.js";
import FloatView from "./floatView.vue";

export default {
  name: 'HomeView',

  components: {
    FloatView
  },

  props: {
    title: String,
    msg: String,
  },


  directives: {
    drag(el, bindings) {
      el.onmousedown = function (e) {
        var disy = e.pageY - el.offsetTop
        document.onmousemove = function (e) {
          let moveTo = e.pageY - disy;
          if (moveTo < 100) {
            moveTo = 100;
          }
          if (moveTo > window.screen.height - 80) {
            moveTo = window.screen.height - 140;
          }
          el.style.top = moveTo + 'px'
        }
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null
        }
      }
    }
  },
  data() {
    return {
      xpValue: 0,
      userPage: 1,
      tgJs: "",
      loginUrl: "",
      isCirce: true,
      rate: 10,
      count: 0,
      dragging: false,
      top: 140,
      startY: 0,
      isUserLoginStatus: false,
      isShowPageMint: false,
      maxXp: 3600,
      loacalXp: 0,
      intervalId: null,
      pageMintNum: 0,
      isDragging: false,
      dragX: 0,
      dragY: 150,
      startX: 0,
      animationFrame: null,
      snapThreshold: 100,
      minY: 0,
      maxY: 0,
    }
  },

  watch: {
  },

  methods: {

    xpDown() {
      let xp_down = document.getElementById('xp_down');
      xp_down.style.display = "flex"
      xp_down.style.top = 0 + 'px'; // 更新位置

      let pointY = 0;
      let interval = setInterval(function () {
        pointY = pointY + 6;
        if (pointY >= 120) {
          pointY = 0;
        }
        xp_down.style.top = pointY + 'px';
      }, 80);

    },



    moveLeftDiv() {
      console.log("moveLeftDiv");
      if (this.isCirce) {
        this.doClose();
        this.getReceive();
        return;
      }
      this.isCirce = true;
      var div = document.getElementById('bee_reward_base_layout');
      var pos = 0;
      let point = -40;
      let interval = setInterval(function () {
        if (point == 10) { // 假设我们想让div移动到页面宽度的350px，然后停止
          clearInterval(interval); // 停止移动
        } else {
          pos += 2; // 每次移动10px
          point = -40 + pos;
          div.style.right = point + 'px'; // 更新位置
        }
      }, 20);
     
    },


    moveRightDiv() {
      this.isCirce = false;
      let div = document.getElementById('bee_reward_base_layout');
      div.style.right = '-40px'; // 更新位置
    },



    doClose() {
      // let view = document.getElementById("bee_nReward");
      // view.style.display = "none";
      this.moveRightDiv();
    },

    getQueryString(url) {
      let ItemArr = [];
      let ItemObj = {};
      url
        .substring(url.lastIndexOf("?") + 1, url.length)
        .split("&")
        .map((item) => {
          ItemArr.push(item.split("="));
        });
      ItemArr.map((item) => {
        ItemObj[item[0]] = item[1];
      });
      return ItemObj;
    },

    async jumpXp() {
      let xp_down = document.getElementById('xp_down');
      xp_down.style.display = "flex";
      let that = this;
      this.xpDown();
      this.intervalId = setInterval(function () {
        // that.xpValue = parseFloat(that.xpValue) + parseFloat(0.2);
        that.xpValue = that.add(that.xpValue, 0.2);
        // that.loacalXp = parseFloat(that.loacalXp) + parseFloat(0.2);
        that.loacalXp = that.add(that.loacalXp, 0.2);

        // let time_rate = that.xpValue % that.rate;
        that.count = that.count + 1;
        let time_rate = that.count % that.rate;
        if (time_rate == 0) {

          if (AccountStore.isUserLoginStatus) {
            // let data = await MintInfoStore.setIncr(that.rate);
            // if (data.code != 200) {
            //   clearInterval(intervalId);
            //   that.reNotify();
            // }
            that.getMintInfo();
          } else {
            localStorage.setItem('mintData', that.xpValue);
          }

        }
        //console.log(time_rate);
        // if (that.xpValue >= that.maxXp) {
        if (that.loacalXp >= that.maxXp) {
          clearInterval(this.intervalId);
          let xp_down = document.getElementById('xp_down');
          xp_down.style.display = "none";
        }
      }, 1000);

    },

    add(num1, num2) {
      let m = Math.pow(10, 2); //放大10的2次方倍  100
      let value = (num1 * m + num2 * m) / m;  //(0.1*100 + 0.2*100）/100
      return value.toFixed(1)
    },

    async getMintInfo() {
      let data = await MintInfoStore.setIncr(this.rate);
      if (data.code != 200) {
        clearInterval(this.intervalId);
        this.reNotify();
      }
    },




    async reNotify() {
      let data = await MintInfoStore.getMintInfo();
      this.xpValue = data.xp;
      this.maxXp = data.xpMintRights;
    },

    async getUserLoginInfo() {
      await AccountStore.fetchUserInfo();
      this.isUserLoginStatus = AccountStore.isUserLoginStatus;
      if (this.isUserLoginStatus) {
        //  localStorage.setItem(key, value);
        let mintData = localStorage.getItem('mintData');
        if (mintData != null && mintData > 1) {
          await MintInfoStore.setIncr(mintData);
          localStorage.setItem('mintData', 0);
        }
        let data = await MintInfoStore.getMintInfo();
        // console.log(data);
        this.xpValue = data.xp;
        this.maxXp = data.xpMintRights;
        if (this.maxXp > 0) {
          await this.jumpXp();
        } else {
          let xp_down = document.getElementById('xp_down');
          xp_down.style.display = "none";
        }
      } else {
        let mintData = localStorage.getItem('mintData');
        if (mintData != null && mintData != undefined) {
          this.xpValue = parseInt(mintData);
        }
        await this.jumpXp();
      }

      // try {
      //   this.xpNumber = AccountStore.accountBindInfo.xp;
      //   console.log(AccountStore.accountBindInfo)
      // } catch {
      // }
      // let view = document.getElementById("bee_reward");
      this.loginUrl = AccountStore.accountInfo.loginUrl;
    },

    async setTimeOutPageMint() {
      let that = this;
      setTimeout(function () {
        that.setPageMint();
      }, 3000);
    },

    async setPageMint() {
      let that = this;
      if (!isHostPage()) {
        const result = await MintInfoStore.setPageMint(hostHref());
        if (result.code == 200) {
          this.reNotify();
          this.pageMintNum = result.data;
          this.isShowPageMint = true;
          console.log(result);
          setTimeout(function () {
            // 
            let gif_mint = document.getElementById('gif_mint');
            gif_mint.style.display = "none";
            let page_mint = document.getElementById('page_mint');
            page_mint.style.display = "flex";
            that.pageNumberRemove();
            setTimeout(function () {
              that.isShowPageMint = false;
            }, 2000);
          }, 2000);
        }
      }
    },


    pageNumberRemove() {
      let page_mint = document.getElementById('page_mint');
      page_mint.style.display = "flex";
      let point = 140;
      let interval = setInterval(function () {
        if (point == 0) { // 假设我们想让div移动到页面宽度的350px，然后停止
          clearInterval(interval); // 停止移动
        } else {
          point = point - 10;
          page_mint.style.marginTop = point + 'px'; // 更新位置
        }
      }, 100);
    },

    getReceive() {
      if (!AccountStore.isUserLoginStatus) {
        this.doClose();
        localStorage.setItem('mintData', this.xpValue);
        window.location.href = this.loginUrl;
      } else {
        //
      }

    },



    handleTouchStart(event) {
      this.startY = event.touches[0].pageY;
    },
    handleTouchMove(event) {
      const currentY = event.touches[0].pageY;
      const distanceY = currentY - this.startY;
      this.top += distanceY;
      this.startY = currentY;
    },

    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX - this.dragX;
      this.startY = event.clientY - this.dragY;
      
      // 计算最大Y值（屏幕高度减去元素高度）
      this.maxY = window.innerHeight - 63; // 63是元素高度
      
      // Add global event listeners
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
      
      // Prevent default to avoid text selection
      event.preventDefault();
    },
    
    onDrag(event) {
      if (!this.isDragging) return;
      // Use requestAnimationFrame for smooth animation
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
      
      this.animationFrame = requestAnimationFrame(() => {
        const newX = event.clientX - this.startX;
        const newY = event.clientY - this.startY;
        
        // Calculate bounds
        const maxX = window.innerWidth - 100;
        
        // 限制Y轴范围
        this.dragY = Math.max(this.minY, Math.min(newY, this.maxY));
        this.dragX = Math.max(-maxX, Math.min(newX, maxX));
        if(this.dragY>=window.innerHeight-50){
          this.dragY = window.innerHeight-100;
        }
        

      });
    },
    
    stopDrag() {
      this.isDragging = false;
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
      // Remove global event listeners
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      // Snap to nearest edge
      // this.snapToEdge();
      if (Math.abs(endX - this.startX) < 10 && Math.abs(endY - this.startY) < 10) {
        this.moveLeftDiv();
      } else {
        // 否则执行吸附
        this.snapToEdge();
      }
    },
    
    snapToEdge() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const elementWidth = 76; // reward_content 的宽度
      const elementHeight = 80; // reward_content 的高度
      
      // 计算到左右边缘的距离
      const distanceToLeft = Math.abs(this.dragX);
      const distanceToRight = Math.abs(windowWidth - (this.dragX + elementWidth));
      
      // 确定最近的垂直边缘
      if (distanceToLeft < distanceToRight) {
        // 吸附到左边缘
        this.dragX = 0;
      } else {
        // 吸附到右边缘
        this.dragX = windowWidth - elementWidth;
      }
      
      // 确保垂直位置在可视区域内
      this.dragY = Math.max(0, Math.min(this.dragY, windowHeight - elementHeight));
      if(this.dragY >= windowHeight - 50) {
        this.dragY = windowHeight - 100;
      }

      this.moveLeftDiv();
    },

    startTouchDrag(event) {
      event.preventDefault(); // 防止页面滚动
      this.isDragging = true;
      const touch = event.touches[0];
      this.startX = touch.clientX - this.dragX;
      this.startY = touch.clientY - this.dragY;
      
      // Add touch event listeners
      document.addEventListener('touchmove', this.onTouchDrag, { passive: false });
      document.addEventListener('touchend', this.stopTouchDrag);
    },
    
    onTouchDrag(event) {
      if (!this.isDragging) return;
      event.preventDefault(); // 防止页面滚动
      
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
      
      this.animationFrame = requestAnimationFrame(() => {
        const touch = event.touches[0];
        const newX = touch.clientX - this.startX;
        const newY = touch.clientY - this.startY;
        
        // Calculate bounds
        const maxX = window.innerWidth - 100;
        const maxY = window.innerHeight - 100;
        
        this.dragX = Math.max(-maxX, Math.min(newX, maxX));
        this.dragY = Math.max(-maxY, Math.min(newY, maxY));
      });
    },
    
    stopTouchDrag(event) {
      this.isDragging = false;
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
      
      // Remove touch event listeners
      document.removeEventListener('touchmove', this.onTouchDrag);
      document.removeEventListener('touchend', this.stopTouchDrag);
      
      // 检查是否是点击而不是拖动
      const touch = event.changedTouches[0];
      const endX = touch.clientX;
      const endY = touch.clientY;
      
      // 如果移动距离很小，认为是点击
      if (Math.abs(endX - this.startX) < 10 && Math.abs(endY - this.startY) < 10) {
        this.moveLeftDiv();
      } else {
        // 否则执行吸附
        this.snapToEdge();
      }
    },

  },

  async mounted() {
    // this.xpDown();
    // await this.jumpXp();
    await this.getUserLoginInfo();


    this.setTimeOutPageMint();

  },

  beforeDestroy() {
    // Clean up all event listeners
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('touchmove', this.onTouchDrag);
    document.removeEventListener('touchend', this.stopTouchDrag);
  }

}

</script>

<style scoped>
.bee_reward_base_layout {
  position: fixed;
  z-index: 2001;
  align-items: center;
  flex-direction: column;
  right: 10px;
  display: flex;
}

.reward_content_radius {
  width: 76px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  flex-direction: column;
  background-color: #F29100;
  margin-left: -4px;
  border-radius: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  border: 1px solid #fff;
}

.reward_content {
  /* background-image: url("../assets/icon_mint.png"); */
  background-image: url("https://www.bee.com/wp-content/uploads/2024/11/icon_mint.png");
  width: 68px;
  height: 63px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.6;
  cursor: move;
  position: relative;
  will-change: transform; /* Optimize for transform animations */
  transform: translate3d(0, 0, 0); /* Force GPU acceleration */
  transition: transform 0.3s ease; /* 添加平滑过渡效果 */
  touch-action: none; /* 禁用默认的触摸行为 */
  top: 80px;
  /* animation: rotate 10s linear infinite; */
}

@keyframes rotate {
  0% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(720deg);
  }
}

.line {
  width: 1px;
  height: 150px;
  background-color: #f2f2f2;
}

.bee_experience_logo {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 100%;
  margin-left: 2px;
  /* background-image: url("../assets/icon_task_xp.png");
  background-size: cover;
  background-repeat: no-repeat; */
}


.icon_app_close_img {
  width: 16px;
  height: 16px;
  background-image: url("../assets/icon_dialog_close.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  margin-top: 4px;
}

.reward_xp_layout {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.reward_text {
  font-size: 10px;
  color: #00c170;
  height: 16px;
  border-radius: 30px;
  background: #c6ffe7;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 2px;
  margin-top: 2px;
}

.mint_txt {
  color: #fff;
  font-size: 16px;
  width: 40px;
  text-align: center;
}

.xp_gif {
  width: 50px;
  height: 140px;
  flex-shrink: 0;
  background-image: url("../assets/page_xp.gif");
  background-size: cover;
  background-repeat: no-repeat;
}

.bee_reward_pg_layout {
  position: fixed;
  z-index: 2001;
  align-items: center;
  flex-direction: column;
  right: 0;
  /* left: 0; */
  display: flex;
}

.icon_xp_img {
  position: fixed;
  align-items: center;
  flex-direction: column;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  background-image: url("../assets/icon_XP.png");
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.6;
  display: none;
}

.xp_txt {
  color: #fff;
  font-size: 14px;
  line-height: 14px;
}

.xp_login {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
}

.pageMintNum {
  margin-top: 140px;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  color: #F6840B;
  width: 50px;
  align-items: center;
  justify-content: center;
}
</style>
